import React from 'react';
import { Card, CardContent, Typography, Box, Avatar, Skeleton } from '@mui/material';
import { useSpring, animated } from '@react-spring/web';
import { useSelector } from 'react-redux';
import NorthEast from '@mui/icons-material/NorthEast';
import SouthEast from '@mui/icons-material/SouthEast';
import { getCurrencySymbolV2} from '../../../../utils/currency';

const StatCard = ({ title, details, subtitle, isPositive, isLoading, isPrice = true }) => {
	const selectedCurrency = useSelector((state) => state.main.selectedCurrency);

	const { animatedValue } = useSpring({
		from: { animatedValue: 0 },
		to: { animatedValue: isPrice ? details?.[selectedCurrency] || 0 : details || 0 },
        delay: 0,
        config: { mass: 1, tension: 120, friction: 14 },
	});

	const percentageColor = isPositive ? '#4CAF50' : '#F44336';
	const avatarBgColor = isPositive ? '#E8F5E9' : '#FFEBEE';
	const avatarIconColor = isPositive ? '#4CAF50' : '#F44336';
	const TrendIcon = isPositive ? NorthEast : SouthEast;

	return (
		<Card sx={{
			borderRadius: 3,
			boxShadow: '0 4px 12px rgb(0 0 0 / 0.05)',
			height: '107px',
			display: 'flex',
			alignItems: 'center',
			mb: 2,
		}}>
			<CardContent sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				width: '100%',
				p: 2.5,
				'&:last-child': { pb: 2.5 }
			}}>
				{isLoading ? (
					<Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
						<Skeleton variant="circular" width={48} height={48} sx={{ mr: 2 }} />
						<Box sx={{ flexGrow: 1 }}>
							<Skeleton variant="text" width="70%" height={24} />
							<Skeleton variant="text" width="40%" height={20} />
						</Box>
						<Skeleton variant="text" width="30%" height={40} />
					</Box>
				) : (
					<>
						<Box sx={{ display: 'flex', alignItems: 'center' }}>
							<Avatar sx={{ bgcolor: avatarBgColor, width: 48, height: 48, mr: 2 }}>
								<TrendIcon sx={{ color: avatarIconColor }} />
							</Avatar>
							<Box>
								<div className={`text-lg fw-500`}>
									{title}
								</div>
								{subtitle && (
									<Typography variant="body2" sx={{ color: percentageColor, fontWeight: 500 }}>
										{subtitle}
									</Typography>
								)}
							</Box>
						</Box>

						<div className="flex gap-1 justify-between align-items-center">
							{
								isPrice ? (
									<>
										<div style={{ marginTop: `${selectedCurrency === 'aed' ? '-2px' : '0'}`, fontSize: '18px' }}>
											{getCurrencySymbolV2(selectedCurrency, 'usd', '20px', '16px')}
										</div>
										<animated.span style={{ fontSize: '15px', fontWeight: '400' }}>
											{animatedValue.to((n) => n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))}
										</animated.span>
									</>
								) : (
										<animated.span style={{ fontSize: '15px', fontWeight: '400' }}>
											{animatedValue.to((n) => n.toLocaleString('en-US', { maximumFractionDigits: 0 }))}
										</animated.span>
								)
							}

							{/* <animated.span style={{ fontSize: '15px', fontWeight: '400' }}>
								{animatedValue.to((n) => n.toLocaleString('en-US', { maximumFractionDigits: 0 }))}
							</animated.span> */}
						</div>
					</>
				)}
			</CardContent>
		</Card>
	);
};

export default StatCard;